const PATHS_TO_HIDE_NAVBAR = [
  '/organisation/project-templates/edit/',
  '/pro/builder/',
  '/elevate/v2/project',
  '/storyboards/edit/',
  '/review/storyboard/'
];

export { PATHS_TO_HIDE_NAVBAR };
